import { Helmet } from "react-helmet-async";
import { useLocation } from "react-router-dom";

const SEO = ({ title, description, url, image, product, keywords, noindex }) => {
  const siteName = "Rekha Collection";
  const baseUrl = "https://rekhacollection.in";
  const location = useLocation();
  const defaultDesc =
    "Rekha Collection (rekhacollection.in) - রেখা কালেকশন | Kolkata's #1 online fashion store. Buy saree, kurti, suit, blouse at best prices. Free delivery in Kolkata, West Bengal & all India. ☎ 7003981213";
  const defaultKeywords =
    "rekha collection, rekhacollection, rekhacollection.in, rekha collection online, rekha collection official, "
    + "rekha collection kolkata, rekha collection newtown, rekha collection west bengal, rekha collection india, "
    + "rekha collection saree, rekha collection kurti, rekha collection suit, "
    + "রেখা কালেকশন, রেখা কালেকশন অনলাইন, রেখা কালেকশন কলকাতা, রেখা কালেকশন অফিসিয়াল, "
    + "রেখা কালেকশন শাড়ি, রেখা কালেকশন কুর্তি, রেখা কালেকশন নিউটাউন, "
    + "online saree shop kolkata, kurti shop kolkata, fashion store kolkata, "
    + "কলকাতা অনলাইন শাড়ি, পশ্চিমবঙ্গ অনলাইন শপিং, কলকাতা ফ্যাশন স্টোর";

  // Brand name FIRST in title for exact match ranking
  const pageTitle = title === "Home"
    ? `Rekha Collection | rekhacollection.in - Online Fashion Store Kolkata | রেখা কালেকশন`
    : title
      ? `${title} - Rekha Collection | rekhacollection.in | রেখা কালেকশন`
      : `Rekha Collection | rekhacollection.in - Online Fashion Store Kolkata | রেখা কালেকশন`;

  const pageDesc = description || defaultDesc;
  const path = url || location.pathname;
  const cleanPath = path === "/" ? "" : path.replace(/\/$/, "");
  const pageUrl = `${baseUrl}${cleanPath}`;
  const pageImage = image || `${baseUrl}/og-image.jpg`;
  const pageKeywords = keywords
    ? `rekha collection, rekhacollection, রেখা কালেকশন, ${keywords}, ${defaultKeywords}`
    : defaultKeywords;

  return (
    <Helmet>
      <title>{pageTitle}</title>
      <meta name="description" content={pageDesc} />
      <meta name="keywords" content={pageKeywords} />
      {noindex ? (
        <meta name="robots" content="noindex, nofollow" />
      ) : (
        <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      )}
      <link rel="canonical" href={pageUrl} />
      <link rel="alternate" hrefLang="en-in" href={pageUrl} />
      <link rel="alternate" hrefLang="bn" href={pageUrl} />
      <link rel="alternate" hrefLang="x-default" href={pageUrl} />

      <meta property="og:title" content={pageTitle} />
      <meta property="og:description" content={pageDesc} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={pageImage} />
      <meta property="og:image:alt" content={`Rekha Collection - ${title || "Official Online Store"}`} />
      <meta property="og:type" content={product ? "product" : "website"} />
      <meta property="og:site_name" content="Rekha Collection" />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:locale:alternate" content="bn_IN" />

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={pageTitle} />
      <meta name="twitter:description" content={pageDesc} />
      <meta name="twitter:image" content={pageImage} />
      <meta name="twitter:image:alt" content={`Rekha Collection - ${title || "Official Online Store"}`} />

      {product && (
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Product",
            name: product.name,
            image: product.primaryImage,
            description: product.description,
            brand: { "@type": "Brand", name: "Rekha Collection" },
            offers: {
              "@type": "Offer",
              price: product.discountPrice,
              priceCurrency: "INR",
              availability: "https://schema.org/InStock",
              url: pageUrl,
              itemCondition: "https://schema.org/NewCondition",
              seller: {
                "@type": "Organization",
                name: "Rekha Collection",
                url: baseUrl,
              },
              shippingDetails: {
                "@type": "OfferShippingDetails",
                shippingDestination: {
                  "@type": "DefinedRegion",
                  addressCountry: "IN",
                  addressRegion: ["WB", "IN"],
                },
                deliveryTime: {
                  "@type": "ShippingDeliveryTime",
                  handlingTime: { "@type": "QuantitativeValue", minValue: 1, maxValue: 2, unitCode: "DAY" },
                  transitTime: { "@type": "QuantitativeValue", minValue: 2, maxValue: 5, unitCode: "DAY" },
                },
                shippingRate: {
                  "@type": "MonetaryAmount",
                  value: "0",
                  currency: "INR",
                },
              },
            },
          })}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
